import styled from 'styled-components';
import { propStyling } from '../../shared/propStyling';
import { textStyles } from '../../shared/textStyles';
import { tombac } from '../../shared/tombac';
export const Heading = styled.div.attrs(_ref => {
  let {
    as,
    level
  } = _ref;
  return {
    as: as !== null && as !== void 0 ? as : 'h' + level
  };
}).withConfig({
  displayName: "Heading"
})(["all:initial;display:block;", " ", " ", ""], tombac.typography.heading, textStyles, propStyling);
//# sourceMappingURL=Heading.js.map